<script lang="ts">
/**
 * Scalar Menu Button component
 *
 * The trigger button for the ScalarMenu dropdown.
 * Displays a logo icon and a caret indicator.
 *
 * @example
 * <ScalarMenuButton :open="false" />
 */
export default {}
</script>

<script setup lang="ts">
import { ScalarIconCaretDown } from '@scalar/icons'

import { ScalarHeaderButton } from '../ScalarHeader'
import { ScalarIcon } from '../ScalarIcon'
import type { ScalarMenuButtonProps, ScalarMenuButtonSlots } from './types'

defineProps<ScalarMenuButtonProps>()

defineSlots<ScalarMenuButtonSlots>()
</script>
<template>
  <ScalarHeaderButton class="gap-0.75 px-2">
    <div class="h-5 w-auto">
      <slot name="logo">
        <ScalarIcon icon="Logo" />
      </slot>
    </div>
    <span class="sr-only">
      <slot name="label">{{ open ? 'Close Menu' : 'Open Menu' }}</slot>
    </span>
    <ScalarIconCaretDown
      class="shrink-0 text-c-3 group-hover/button:text-c-1 size-3.5"
      :class="open ? 'rotate-180' : ''"
      weight="bold" />
  </ScalarHeaderButton>
</template>
